<template>
  <div
    class="modal fade"
    id="customerDetailsModal"
    tabindex="-1"
    aria-labelledby="customerDetailsModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content border-0 shadow">
        <div class="modal-header border-bottom-dashed">
          <div>
            <h5 class="modal-title fw-bold mb-1" id="customerDetailsModalLabel">{{ $t("customer_page.details_title") }}</h5>
            <p class="text-muted mb-0">{{ $t("customer_page.details_description") }}</p>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            :aria-label="$t('common.close')"
          ></button>
        </div>

        <div class="modal-body" v-if="customer">
          <div class="row g-3 mb-4">
            <div class="col-6">
              <div class="detail-card">
                <span class="detail-label">{{ $t("customer_page.customer_code") }}</span>
                <strong>{{ customer.code || $t("customer_page.not_available_short") }}</strong>
              </div>
            </div>
            <div class="col-6">
              <div class="detail-card">
                <span class="detail-label">{{ $t("customer_page.deposit") }}</span>
                <strong>{{ formatCurrency(customer.deposit) }}</strong>
              </div>
            </div>
          </div>

          <ul class="details-list list-style">
            <li>
              <span class="fs-14 text-title">{{ $t("customer_page.customer_name") }}</span>
              <span class="fs-14 fw-bold text-title">{{ customer.name || $t("customer_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("customer_page.phone") }}</span>
              <span class="fs-14 fw-bold text-title">{{ customer.phone || $t("customer_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("customer_page.email") }}</span>
              <span class="fs-14 fw-bold text-title">{{ customer.email || $t("customer_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("customer_page.country") }}</span>
              <span class="fs-14 fw-bold text-title">{{ customer.country || $t("customer_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("customer_page.address") }}</span>
              <span class="fs-14 fw-bold text-title">{{ customer.address || $t("customer_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("customer_page.status") }}</span>
              <span class="status-badge" :class="Number(customer.status || 0) === 1 ? 'status-active' : 'status-inactive'">
                {{ Number(customer.status || 0) === 1 ? $t("customer_page.status_active") : $t("customer_page.status_inactive") }}
              </span>
            </li>
          </ul>
        </div>

        <div v-else class="modal-body py-5 text-center text-muted">
          {{ $t("customer_page.no_customer_selected") }}
        </div>

        <div class="modal-footer border-top-dashed justify-content-end">
          <button type="button" class="btn btn-light px-4" data-bs-dismiss="modal">{{ $t("common.close") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";
import { type Customer } from "@/services/customer";

export default defineComponent({
  name: "CustomerDetails",
  props: {
    customer: {
      type: Object as PropType<Customer | null>,
      default: null,
    },
  },
  setup() {
    useI18n();
    const formatCurrency = (value?: number) => `$${Number(value || 0).toFixed(2)}`;

    return {
      formatCurrency,
    };
  },
});
</script>

<style scoped>
.border-bottom-dashed,
.border-top-dashed {
  border-color: #e7ebf3 !important;
  border-style: dashed !important;
}

.detail-card {
  padding: 14px 16px;
  border: 1px solid #edf1f7;
  border-radius: 14px;
  background: #f9fbff;
}

.detail-label {
  display: block;
  color: #76839a;
  font-size: 13px;
  margin-bottom: 4px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 96px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.status-active {
  color: #1f9254;
  background: #e8f7ee;
}

.status-inactive {
  color: #d33c43;
  background: #fdecec;
}
</style>
